export const GET_SETTINGS_LOADING = 'GET_SETTINGS_LOADING';
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR';
